"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WatchingOff = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var WatchingOff = function WatchingOff() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2885 21.2844L22.6525 21.9204C22.5436 22.0364 22.3916 22.1022 22.2325 22.1022C22.0734 22.1022 21.9214 22.0364 21.8125 21.9204L18.3108 18.4186C16.5855 19.2571 14.6598 19.7127 12.6594 19.7012C7.41554 19.7275 2.68842 16.5441 0.73864 11.6732C0.690499 11.5551 0.666049 11.4287 0.666684 11.3012C0.668217 11.1661 0.692544 11.0322 0.73864 10.9052C1.66982 8.59244 3.22745 6.66188 5.16868 5.27654L2.04849 2.15636C1.93248 2.04748 1.86667 1.89546 1.86667 1.73636C1.86667 1.57725 1.93248 1.42524 2.04849 1.31636L2.68449 0.680358C2.79337 0.564345 2.94539 0.498535 3.10449 0.498535C3.2636 0.498535 3.41561 0.564345 3.52449 0.680358L23.2885 20.4444C23.4045 20.5532 23.4703 20.7053 23.4703 20.8644C23.4703 21.0235 23.4045 21.1755 23.2885 21.2844ZM9.48932 9.59719C9.21642 10.1044 9.06157 10.6847 9.06157 11.3012C9.06157 13.2894 10.6724 14.9012 12.6594 14.9012C13.2597 14.9012 13.8445 14.7511 14.3637 14.4716L9.48932 9.59719Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M24.5801 11.6972C23.9203 13.3358 22.946 14.7826 21.7436 15.9796L16.1363 10.3722C15.8056 9.12987 14.8275 8.15175 13.5857 7.82161L9.13855 3.37449C10.2663 3.05817 11.4491 2.89417 12.6594 2.90117C17.9324 2.84698 22.6965 6.04092 24.6521 10.9412C24.6715 11.0604 24.6715 11.182 24.6521 11.3012C24.656 11.4367 24.6314 11.5716 24.5801 11.6972Z",
    fill: "currentColor"
  }));
};

exports.WatchingOff = WatchingOff;